import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './router/permission'
import './styles/popup-menu.css'

// Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import enLocale from 'element-plus/dist/locale/en.mjs'

// Vue I18n
import { createI18n } from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
import ja from './locales/ja'
import es from './locales/es'
import ko from './locales/ko'
import { storageUtils } from './utils/storage'

// 创建I18n实例
const i18n = createI18n({
  legacy: false,
  locale: storageUtils.getLanguage(), // 从存储中获取语言设置
  fallbackLocale: 'zh', // 回退语言
  messages: {
    zh,
    en,
    ja,
    es,
    ko
  }
})

const app = createApp(App)

// 获取Element Plus语言包
const getElementLocale = (locale) => {
  const localeMap = {
    'zh': zhCn,
    'en': enLocale,
    'ja': zhCn, // 暂时使用中文
    'es': zhCn, // 暂时使用中文
    'ko': zhCn  // 暂时使用中文
  }
  return localeMap[locale] || zhCn
}

// 注册Element Plus
app.use(ElementPlus, {
  locale: getElementLocale(storageUtils.getLanguage())
})

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册I18n
app.use(i18n)

// 注册路由和状态管理
app.use(router)
app.use(store)

app.mount('#app')